import { faShieldCheck } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Form, Input } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useLoading } from '../../lib/hooks/useLoading'
import { AuthStep, useAuthStore } from '../../stores/auth'
import { Action, ButtonWrapper, Description, FormWrapper } from './styles'
import { FormValues } from './types'

export function TwoFactorResetPassword({ email }: { email: string }): React.ReactNode {
  const { t } = useTranslation()
  const [isLoading, withLoading] = useLoading()
  const [getTrustToken, setStep, trustToken] = useAuthStore((state) => [
    state.getTrustToken,
    state.setStep,
    state.trustToken,
  ])

  function handleSubmit(values: Pick<FormValues, 'code'>): void {
    withLoading(getTrustToken({ code: values.code, email }))
  }

  useEffect(() => {
    if (trustToken) setStep(AuthStep.RESET_PASSWORD)
  }, [trustToken])

  return (
    <>
      <Action>{t('auth.twoFactor')}</Action>
      <Description>{t('auth.instructionsTwoFactorResetPassword')}</Description>
      <FormWrapper>
        <Form onFinish={handleSubmit} validateTrigger="onSubmit">
          <Form.Item name="code" rules={[{ required: true, message: t('validations.enterTwoFactor') }]}>
            <Input
              autoFocus
              size="large"
              placeholder={t('placeholders.twoFactor')}
              prefix={<FontAwesomeIcon icon={faShieldCheck} />}
            />
          </Form.Item>
          <Form.Item>
            <Button block disabled={isLoading} loading={isLoading} type="primary" htmlType="submit" size="large">
              {t('actions.continue')}
            </Button>
          </Form.Item>
        </Form>
      </FormWrapper>
      <ButtonWrapper>
        <Button onClick={() => setStep(AuthStep.SIGNIN)} type="link">
          {t('actions.back')}
        </Button>
      </ButtonWrapper>
    </>
  )
}
